<!-- <div class="body">
<div class="container pt-3" *ngIf="detalleSolcitud">
  <div class="row">
    <div class="col-12 col-sm-3 text-start">
      <h4>INFORMACIÓN DE LA SOLICITUD</h4>
    </div>
    <div class="col-12 col-sm-3 text-right">
      <span style="font-size: 45px"><i class="far fa-times-circle"></i></span>
    </div>
    <div class="col-12 col-sm-6 text-start">
      <h4>¿SEGURO QUE DESEAS NEGAR LA SOLICITUD DE ESTE CLIENTE?</h4>
    </div>
  </div>

  <div class="row justify-content-md-center mt-4">
    <div class="col-12 col-sm-3">
      <div class="header-inf">
        No. de Solicitud
      </div>
      <p>{{detalleSolcitud.solicitud.idSolicitud}}</p>
    </div>
    <div class="col-12 col-sm-6">
      <div class="header-inf">
        Nombre del solicitante
      </div>
      <p>{{detalleSolcitud.InformacionBeneficiario.PrimerNombre}} {{detalleSolcitud.InformacionBeneficiario.PrimerApellido}}</p>
    </div>
    <div class="col-12 col-sm-3">
      <div class="header-inf">
        Monto solicitado
      </div>
      <p>{{detalleSolcitud.solicitud.monto | currency:'USD' : 'symbol' : '1.0-0'}}</p>
    </div>
  </div>

  <div class="row justify-content-md-center">
    <div class="col-12 col-sm-3">
      <div class="header-inf">
        Tipo de Identificación
      </div>
      <p>{{detalleSolcitud.InformacionBeneficiario.TipoDeDocumentoDeIdentidad}}</p>
    </div>
    <div class="col-12 col-sm-6">
      <div class="header-inf">
        Número de identificación
      </div>
      <p>{{detalleSolcitud.InformacionBeneficiario.NumeroDeDocumento}}</p>
    </div>
    <div class="col-12 col-sm-3">
      <div class="header-inf">
        Plazo solicitado (meses)
      </div>
      <p>{{detalleSolcitud.solicitud.plazo}}</p>
    </div>
  </div>

  <div class="row justify-content-md-center">
    <div class="col-12 col-sm-12">
      <div class="header-inf">
        Destino del crédito
      </div>
      <p>{{detalleSolcitud.solicitud.destino}}</p>
    </div>
  </div>
  <div class="row justify-content-md-center mt-4">
    <div class="col-12 col-sm-12">
      <div class="header-inf">
        Número de Solicitud
      </div>
      <p>{{detalleSolcitud.solicitud.idSolicitud}}</p>
    </div>
  </div>
  <div class="row justify-content-md-center">
    <div class="col-12 col-sm-8 text-start">
      <p>Motivo de la negación</p>
      <select type="number" class="selectpicker" data-width="90%" name="tipoNegacion" [(ngModel)]="tipoNegacionId" required>
        <option [value]="0">Seleccione una opción</option>
        <option [(value)]="tipoNegacion.idTipoNegacion" *ngFor="let tipoNegacion of tiposNegacion">{{tipoNegacion.nombre}}</option>
      </select>
    </div>
  </div>
  <div class="row justify-content-md-center mt-4">
    <div class="col-12 col-sm-2">
      <button class="btn btn-primary" (click)="negar()">Negar</button>
    </div>
    <div class="col-12 col-sm-2">
      <button class="btn btn-primary" (click)="cancelar()">Volver</button>
    </div>
  </div>
</div>
<div class="footer-body"></div>
</div> -->

<app-ver-detalle-propuesta>
  <span class="app">
    <div class="row justify-content-center mt-4">
      <div class="col-12 col-sm-3 text-start">
        <h4>INFORMACIÓN DE LA SOLICITUD</h4>
      </div>
      <div class="col-12 col-sm-3 text-right">
        <span style="font-size: 45px"><i class="far fa-times-circle"></i></span>
      </div>
      <div class="col-12 col-sm-6 text-start">
        <h4>¿SEGURO QUE DESEAS NEGAR LA SOLICITUD DE ESTE CLIENTE?</h4>
      </div>
    </div>
  </span>
  <div class="row justify-content-md-center mt-2">
    <div class="col-12 col-sm-8 text-start">
      <p>Motivo de la negación</p>
      <select type="number" class="selectpicker" data-width="90%" name="tipoNegacion" [(ngModel)]="tipoNegacionId"
        required>
        <option [value]="0">Seleccione una opción</option>
        @for (tipoNegacion of tiposNegacion; track tipoNegacion) {
          <option [(value)]="tipoNegacion.idTipoNegacion">
          {{tipoNegacion.nombre}}</option>
        }
      </select>
    </div>
  </div>
  <div class="row justify-content-md-center mt-4 g-3">
    <div class="col-12 col-sm-2">
      <button class="btn btn-primary" (click)="negar()">Negar</button>
    </div>
    <div class="col-12 col-sm-2">
      <button class="btn btn-primary" (click)="cancelar()">Volver</button>
    </div>
  </div>
</app-ver-detalle-propuesta>

<!-- Modal -->
<div class="modal fade text-center" id="aceptarModal" tabindex="-1" aria-labelledby="aceptarModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-body-monto justify-content-md-center">
        <div class="row">
          <div class="col-12 col-sm-12 me-3 ms-3">
            <h3>La oferta ha sido negada correctamente</h3>
          </div>
        </div>
      </div>
      <div class="modal-footer justify-content-md-center">
        <button type="button" class="btn btn-primary" (click)="aceptar()">Aceptar</button>
      </div>
    </div>
  </div>
</div>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
